import { __decorate, __extends, __metadata } from "tslib";
import { Component, Input, Output } from 'angular-ts-decorators';
import { EntitySelectComponent } from 'src/Foundation/Design/app';
import template from './product-filter-select.component.html';
var ProductFilterSelectComponent = (function (_super) {
    __extends(ProductFilterSelectComponent, _super);
    function ProductFilterSelectComponent() {
        return _super.call(this) || this;
    }
    ProductFilterSelectComponent.prototype.ngOnChanges = function () {
        this.entities = this.filters || [];
    };
    ProductFilterSelectComponent.$inject = [];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ProductFilterSelectComponent.prototype, "clearAllText", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ProductFilterSelectComponent.prototype, "emptySelectionText", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ProductFilterSelectComponent.prototype, "filters", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], ProductFilterSelectComponent.prototype, "onSelectionChange", void 0);
    ProductFilterSelectComponent = __decorate([
        Component({
            selector: 'productFilterSelect',
            template: template,
        }),
        __metadata("design:paramtypes", [])
    ], ProductFilterSelectComponent);
    return ProductFilterSelectComponent;
}(EntitySelectComponent));
export { ProductFilterSelectComponent };
